const changelog = `
`;

const appConfig = {
  version: '1.0.0',
  contactEmail: 'ebov.app@gmail.com',
  changelog,
};

export default appConfig;
